import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DatabaseProvider } from '../../providers/database/database';
import { Observable } from "rxjs/Observable";
import * as _ from 'lodash';
import { AngularFireFunctions } from 'angularfire2/functions';

interface UserProperties {
  clinic_id ? : string;
  clinic_name ? : string;
  email ? : string;
  password ? : string;
  phone ? : string;
  name ? : string;
}

@IonicPage()
@Component({
  selector: 'page-admin-utility',
  templateUrl: 'admin-utility.html',
})

export class AdminUtilityPage {

  document_path: string = 'clinics/';
  document_id: string = 'EA9TDWfZgBVNfXhGXYzG'
  document_path_new: string = '';
  document_id_new: string = '';
  document: any;

  collection_path: string = '';
  collection_path_new: string = '';
  collection: any;

  public clinicList: Observable<any[]>;
  clinic: string;
  clinic_name: string;
  clinic_id: string;

  user: any = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, private database: DatabaseProvider, private afFun: AngularFireFunctions,) {
    this.clinicList = this.database
    .getClinics()
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminUtilityPage');
  }

  getDoc()  {
    console.log(this.document_path)
    this.database.getDoc(this.document_path, this.document_id)
    .valueChanges()
    .subscribe((data) => {
      console.log(data);
      this.document = JSON.stringify(data);
    })
  }

  updateDoc() {
    this.database.updateDoc(this.document_path, this.document_id, JSON.parse(this.document))
  }

  setDoc()  {
    this.database.setDoc(this.document_path_new, this.document_id_new, JSON.parse(this.document))
  }

  setDocWithID() {
    this.database.setDocWithID(this.document_path_new, JSON.parse(this.document))
  }

  getCollection() {
    console.log(this.collection_path)
    this.database.getCollection(this.collection_path)
    .snapshotChanges()
    .subscribe((data) => {
      console.log(data);

      let cache: any;
      this.collection = JSON.stringify(data, function(key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
  return value;
});
    })
  }

  setCollection() {
    let parseJSON = JSON.parse(this.collection)

    _(parseJSON).forEach((item) => {
      let document = _.omit(item, ['id']);
      this.database.setDocWithID(this.collection_path_new, document).then(_ => {
        console.log("Doc added: ", document);
      })
      .catch((err) => {
        console.log("Error adding document: ", document);
      })

    });

  }

  async createTestUser()  {
    console.log("Creating test user:", this.user)
      // Angular Fire - Converts Promise to Observable
    let testuser: UserProperties = {clinic_id: "3serdsdff3446", clinic_name: "Test Clinic", email: null, password: null, phone: null, name: null};
    testuser.email = this.user.email;
    testuser.password = this.user.password;
    testuser.phone = this.user.phone;
    testuser.name = this.user.name;

    console.log("Creating test user properties:", testuser);

    const respRef = await this.afFun.httpsCallable('addUser')(testuser).toPromise();
    console.log(respRef)
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-utility/admin-utility.ts